import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import { helpers, maxLength } from '@vuelidate/validators'
import validationMixinGeneral from '@apps/order-form/src/mixins/validationMixinGeneral'
import { GENERAL_STORE } from '../store'

export default {
  data: () => ({
    cardNumberFocused: false,
  }),

  mixins: [validationMixinGeneral],

  validations() {
    return {
      cardNumber: {
        hasNumOrAlphaNum: helpers.withMessage('Укажите номер карты / телефона', val =>
          /\d|\d.*[a-zA-Z]/.test(val)
        ),
        maxLength: helpers.withMessage(
          ({ $params, $model }) => `Максимальная длина поля превышена на
      ${$model.length - $params.max}
      символов`,
          maxLength(100)
        ),
      },
    }
  },

  computed: {
    ...mapState(GENERAL_STORE, ['user', 'order', 'incomeReturnMethods', 'advanceCheque', 'form']),
    ...mapGetters(GENERAL_STORE, ['totalItemsPrice', 'refundableAmount']),

    lastWalletValue() {
      return String(this.form.lastWalletValue || '')
    },

    cardNumber: {
      get() {
        return this.order.wallet || ''
      },
      set(value) {
        this.updateOrder({
          key: 'wallet',
          value,
        })
      },
    },

    returnMethod: {
      // тип банковской карты на которую необходимо вернуть деньги 0 => 'Карта сбербанка', 1 => 'ЮMoney (Я.Деньги)', 2 => 'QIWI'
      get() {
        return this.order.incomeReturnMethod
      },
      set(value) {
        this.updateOrder({
          key: 'incomeReturnMethod',
          value,
        })
        this.calculatePrice()
        // this.setIncomeReturnCardNumber("");
        //! КОСТЫЛЬ ДЛЯ КАССОВОГО ОБСЛУЖИВАНИЯ
        // <<<<<<<<<<<<
        // this.manageReturnMethods();
        //! КОНЕЦ КОСТЫЛЯ ДЛЯ КАССОВОГО ОБСЛУЖИВАНИЯ
        // this.$v.cardNumber.$params.required.prop();
        // this.validateForm();

        // <<<<<<<<<<<<
        // this.$nextTick(() => {
        //   if (this.$refs.cardNumberInput) {
        //     this.$refs.cardNumberInput.focus();
        //   }
        // });
      },
    },

    methodsList() {
      if (this.user.isLegalEntity) {
        return this.incomeReturnMethods.filter(method => +method.value === 0 || +method.value === 3)
      }

      return this.incomeReturnMethods.filter(method => +method.value !== 3)
    },

    placeholderValue() {
      const method = this.incomeReturnMethods.find(
        methodItem => methodItem.value === this.order.incomeReturnMethod
      )

      return method ? method.inputPlaceholder : undefined
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, ['updateOrder']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
  },

  mounted() {
    this.addFieldValidator('cardNumber', this.$refs.incomeBlock.$el)
  },
  // destroyed() {
  //   this.validateForm();
  // },
}
